var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCtvSonyStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7466_3283)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.345579 10.9774C-0.253239 11.3967 -0.142363 12.1192 1.22384 12.5709C2.59005 13.0227 4.17801 13.1162 5.57525 12.8645C5.6551 12.8645 5.53535 12.8645 5.57525 12.8645V11.4387L4.21794 11.9C3.69896 12.0677 3.17998 12.1097 2.66101 11.9838C2.2618 11.858 2.34164 11.6065 2.82069 11.3968L5.57525 10.3903V8.8387L1.74282 10.2226C1.26377 10.3903 0.784714 10.6419 0.345579 10.9774ZM9.6073 4.6871V8.75485C11.244 9.59355 12.5215 8.75485 12.5215 6.5742C12.5215 4.35162 11.763 3.34516 9.5674 2.54838C8.40965 2.12903 7.21205 1.75161 6.0144 1.5V13.6194L8.8089 14.5V4.30968C8.8089 3.84839 8.8089 3.51291 9.12825 3.63871C9.5674 3.76452 9.6073 4.22581 9.6073 4.6871ZM14.797 10.0129C13.6393 9.59355 12.4018 9.4258 11.2041 9.5516C10.5389 9.5953 9.9147 9.79345 9.28795 10.0129V11.6484L11.8828 10.6419C12.4018 10.4742 12.9207 10.4323 13.4397 10.5581C13.8389 10.6839 13.7591 10.9355 13.28 11.1452L9.28795 12.6967V14.2903L14.797 12.1516C15.1962 11.9838 15.5555 11.7742 15.8749 11.4387C16.1544 11.0193 16.0346 10.4323 14.797 10.0129Z",
    fill: "#0070D1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7466_3283"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCtvSonyStore);
export default __webpack_public_path__ + "static/media/ctv_sony_store.611d860c55873300506a0f83aca251fb.svg";
export { ForwardRef as ReactComponent };